// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.VariableInsertField_field__ERrBf {
  width: 100%;
}

.VariableInsertField_input__\\+oHjc,
.VariableInsertField_textarea__u43-W {
  font-size: 14px;
  width: 100%;
  padding: 8px 12px;
  border: 1px solid var(--m-border, #e2e5e8);
  border-radius: 6px;
  background: var(--m-card-background-color, #fff);
  color: inherit;
  transition: border-color 0.15s ease, box-shadow 0.15s ease;
}
.VariableInsertField_input__\\+oHjc:focus,
.VariableInsertField_textarea__u43-W:focus {
  outline: none;
  border-color: var(--m-primary, #005fed);
  box-shadow: 0 0 0 2px var(--m-background-subtle-primary, rgba(0, 95, 237, 0.12));
}

.VariableInsertField_textarea__u43-W {
  resize: vertical;
  min-height: 88px;
}

.VariableInsertField_chipsSection__xtU6l {
  margin-top: 10px;
}

.VariableInsertField_chipsLabel__a5hg2 {
  font-size: 12px;
  color: var(--m-text-subtle, #6b778c);
  margin-bottom: 8px;
}

.VariableInsertField_chipsScroller__97bjt {
  position: relative;
}
.VariableInsertField_chipsScroller__97bjt::before, .VariableInsertField_chipsScroller__97bjt::after {
  content: "";
  position: absolute;
  top: 0;
  bottom: 0;
  width: 18px;
  pointer-events: none;
  z-index: 1;
}
.VariableInsertField_chipsScroller__97bjt::before {
  left: 0;
  background: linear-gradient(to right, var(--m-card-background-color, #fff), transparent);
}
.VariableInsertField_chipsScroller__97bjt::after {
  right: 0;
  background: linear-gradient(to left, var(--m-card-background-color, #fff), transparent);
}

.VariableInsertField_chipsTrack__\\+3z6o {
  display: flex;
  flex-wrap: nowrap;
  gap: 8px;
  overflow-x: auto;
  overflow-y: hidden;
  padding: 2px 4px 8px;
  scroll-snap-type: x proximity;
  scroll-behavior: smooth;
  -webkit-overflow-scrolling: touch;
  scrollbar-width: thin;
  scrollbar-color: var(--m-border, #dfe1e6) transparent;
}
.VariableInsertField_chipsTrack__\\+3z6o::-webkit-scrollbar {
  height: 4px;
}
.VariableInsertField_chipsTrack__\\+3z6o::-webkit-scrollbar-thumb {
  background: var(--m-border, #dfe1e6);
  border-radius: 999px;
}
.VariableInsertField_chipsTrack__\\+3z6o::-webkit-scrollbar-track {
  background: transparent;
}

.VariableInsertField_chip__n8h1I {
  flex: 0 0 auto;
  scroll-snap-align: start;
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 6px 12px;
  border: 1px solid var(--m-border, #dfe1e6);
  border-radius: 999px;
  background: var(--m-background-subtle-primary, #ebf3ff);
  color: var(--m-primary, #005fed);
  font-size: 12px;
  font-weight: 500;
  line-height: 1.2;
  white-space: nowrap;
  cursor: pointer;
  transition: background 0.15s ease, border-color 0.15s ease, transform 0.1s ease;
}
.VariableInsertField_chip__n8h1I:hover {
  background: var(--m-primary, #005fed);
  border-color: var(--m-primary, #005fed);
  color: #fff;
}
.VariableInsertField_chip__n8h1I:active {
  transform: scale(0.97);
}
.VariableInsertField_chip__n8h1I:focus-visible {
  outline: none;
  box-shadow: 0 0 0 2px var(--m-background-subtle-primary, rgba(0, 95, 237, 0.25));
}

.VariableInsertField_chipIcon__8fD71 {
  font-size: 13px;
  line-height: 1;
  opacity: 0.85;
}

.VariableInsertField_preview__wgg32 {
  margin-top: 10px;
  padding: 10px 12px;
  border-radius: 6px;
  font-size: 13px;
  line-height: 1.45;
  background: var(--m-background-neutral-subtle, #f4f5f7);
  border: 1px solid var(--m-border, #e2e5e8);
}

.VariableInsertField_previewLabel__U8Qyz {
  display: block;
  font-size: 11px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: var(--m-text-subtle, #6b778c);
  margin-bottom: 4px;
}

.VariableInsertField_previewText__y5ZdC {
  color: inherit;
  word-break: break-word;
}`, "",{"version":3,"sources":["webpack://./src/views/pages/NotificationSettings/VariableInsertField.module.scss"],"names":[],"mappings":"AAAA;EACE,WAAA;AACF;;AAEA;;EAEE,eAAA;EACA,WAAA;EACA,iBAAA;EACA,0CAAA;EACA,kBAAA;EACA,gDAAA;EACA,cAAA;EACA,0DAAA;AACF;AACE;;EACE,aAAA;EACA,uCAAA;EACA,gFAAA;AAEJ;;AAEA;EACE,gBAAA;EACA,gBAAA;AACF;;AAEA;EACE,gBAAA;AACF;;AAEA;EACE,eAAA;EACA,oCAAA;EACA,kBAAA;AACF;;AAEA;EACE,kBAAA;AACF;AACE;EAEE,WAAA;EACA,kBAAA;EACA,MAAA;EACA,SAAA;EACA,WAAA;EACA,oBAAA;EACA,UAAA;AAAJ;AAGE;EACE,OAAA;EACA,wFAAA;AADJ;AAIE;EACE,QAAA;EACA,uFAAA;AAFJ;;AAMA;EACE,aAAA;EACA,iBAAA;EACA,QAAA;EACA,gBAAA;EACA,kBAAA;EACA,oBAAA;EACA,6BAAA;EACA,uBAAA;EACA,iCAAA;EACA,qBAAA;EACA,qDAAA;AAHF;AAKE;EACE,WAAA;AAHJ;AAME;EACE,oCAAA;EACA,oBAAA;AAJJ;AAOE;EACE,uBAAA;AALJ;;AASA;EACE,cAAA;EACA,wBAAA;EACA,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,iBAAA;EACA,0CAAA;EACA,oBAAA;EACA,uDAAA;EACA,gCAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,mBAAA;EACA,eAAA;EACA,+EAAA;AANF;AAQE;EACE,qCAAA;EACA,uCAAA;EACA,WAAA;AANJ;AASE;EACE,sBAAA;AAPJ;AAUE;EACE,aAAA;EACA,gFAAA;AARJ;;AAYA;EACE,eAAA;EACA,cAAA;EACA,aAAA;AATF;;AAYA;EACE,gBAAA;EACA,kBAAA;EACA,kBAAA;EACA,eAAA;EACA,iBAAA;EACA,uDAAA;EACA,0CAAA;AATF;;AAYA;EACE,cAAA;EACA,eAAA;EACA,gBAAA;EACA,yBAAA;EACA,sBAAA;EACA,oCAAA;EACA,kBAAA;AATF;;AAYA;EACE,cAAA;EACA,sBAAA;AATF","sourcesContent":[".field {\n  width: 100%;\n}\n\n.input,\n.textarea {\n  font-size: 14px;\n  width: 100%;\n  padding: 8px 12px;\n  border: 1px solid var(--m-border, #e2e5e8);\n  border-radius: 6px;\n  background: var(--m-card-background-color, #fff);\n  color: inherit;\n  transition: border-color 0.15s ease, box-shadow 0.15s ease;\n\n  &:focus {\n    outline: none;\n    border-color: var(--m-primary, #005fed);\n    box-shadow: 0 0 0 2px var(--m-background-subtle-primary, rgba(0, 95, 237, 0.12));\n  }\n}\n\n.textarea {\n  resize: vertical;\n  min-height: 88px;\n}\n\n.chipsSection {\n  margin-top: 10px;\n}\n\n.chipsLabel {\n  font-size: 12px;\n  color: var(--m-text-subtle, #6b778c);\n  margin-bottom: 8px;\n}\n\n.chipsScroller {\n  position: relative;\n\n  &::before,\n  &::after {\n    content: \"\";\n    position: absolute;\n    top: 0;\n    bottom: 0;\n    width: 18px;\n    pointer-events: none;\n    z-index: 1;\n  }\n\n  &::before {\n    left: 0;\n    background: linear-gradient(to right, var(--m-card-background-color, #fff), transparent);\n  }\n\n  &::after {\n    right: 0;\n    background: linear-gradient(to left, var(--m-card-background-color, #fff), transparent);\n  }\n}\n\n.chipsTrack {\n  display: flex;\n  flex-wrap: nowrap;\n  gap: 8px;\n  overflow-x: auto;\n  overflow-y: hidden;\n  padding: 2px 4px 8px;\n  scroll-snap-type: x proximity;\n  scroll-behavior: smooth;\n  -webkit-overflow-scrolling: touch;\n  scrollbar-width: thin;\n  scrollbar-color: var(--m-border, #dfe1e6) transparent;\n\n  &::-webkit-scrollbar {\n    height: 4px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: var(--m-border, #dfe1e6);\n    border-radius: 999px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: transparent;\n  }\n}\n\n.chip {\n  flex: 0 0 auto;\n  scroll-snap-align: start;\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  padding: 6px 12px;\n  border: 1px solid var(--m-border, #dfe1e6);\n  border-radius: 999px;\n  background: var(--m-background-subtle-primary, #ebf3ff);\n  color: var(--m-primary, #005fed);\n  font-size: 12px;\n  font-weight: 500;\n  line-height: 1.2;\n  white-space: nowrap;\n  cursor: pointer;\n  transition: background 0.15s ease, border-color 0.15s ease, transform 0.1s ease;\n\n  &:hover {\n    background: var(--m-primary, #005fed);\n    border-color: var(--m-primary, #005fed);\n    color: #fff;\n  }\n\n  &:active {\n    transform: scale(0.97);\n  }\n\n  &:focus-visible {\n    outline: none;\n    box-shadow: 0 0 0 2px var(--m-background-subtle-primary, rgba(0, 95, 237, 0.25));\n  }\n}\n\n.chipIcon {\n  font-size: 13px;\n  line-height: 1;\n  opacity: 0.85;\n}\n\n.preview {\n  margin-top: 10px;\n  padding: 10px 12px;\n  border-radius: 6px;\n  font-size: 13px;\n  line-height: 1.45;\n  background: var(--m-background-neutral-subtle, #f4f5f7);\n  border: 1px solid var(--m-border, #e2e5e8);\n}\n\n.previewLabel {\n  display: block;\n  font-size: 11px;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.04em;\n  color: var(--m-text-subtle, #6b778c);\n  margin-bottom: 4px;\n}\n\n.previewText {\n  color: inherit;\n  word-break: break-word;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"field": `VariableInsertField_field__ERrBf`,
	"input": `VariableInsertField_input__+oHjc`,
	"textarea": `VariableInsertField_textarea__u43-W`,
	"chipsSection": `VariableInsertField_chipsSection__xtU6l`,
	"chipsLabel": `VariableInsertField_chipsLabel__a5hg2`,
	"chipsScroller": `VariableInsertField_chipsScroller__97bjt`,
	"chipsTrack": `VariableInsertField_chipsTrack__+3z6o`,
	"chip": `VariableInsertField_chip__n8h1I`,
	"chipIcon": `VariableInsertField_chipIcon__8fD71`,
	"preview": `VariableInsertField_preview__wgg32`,
	"previewLabel": `VariableInsertField_previewLabel__U8Qyz`,
	"previewText": `VariableInsertField_previewText__y5ZdC`
};
export default ___CSS_LOADER_EXPORT___;
